import { useEffect, useState } from "react";
import { apiCallSPPost, apiExportToExcel } from "src/_apiConfig/apiCall";
import Auth from "src/auth";

import SearchFilter from "../Component/searchFilter";
import { SearchFilterModel } from "../Component/SearchFilterModel";
import { updateSearchStatus } from "src/views/common/CommonSearch";
import CommonList from "src/views/common/CommonList";

const PBSMSPaymentReceivedLotWiseReport = () => {
  const { authenticated } = Auth();
  const [usersData, setUsersData] = useState(); // List Data Set
  const [pageCount, setPageCount] = useState(0); // List Data pagging manage
  const [loading, setloading] = useState(false); // page loading
  const [pageLimit, setpageLimit] = useState(0); // pageing index manage
  const [itemPerPage, setItemPerPage] = useState(10); // Record Show Each Page
  const [disabledprev, setdisabledprev] = useState(false); //Pagging Prev. Button disabled manage
  const [disablednext, setdisablednext] = useState(false); //Pagging Next Button disabled manage
  const [isSearch, setIsSearch] = useState(false); // Search Button Effect Manage
  const [isClear, setIsClear] = useState(false); // Clear Button Effect Manage
  const [isExporting, setIsExporting] = useState(false); //Export To Excel Loader Manage

  const [search, setSearch] = useState(SearchFilterModel); // Search Model

  // Page  API URL manage
  const ReportListUrl = `Report/PBSMS/PaymentReceived/Lot`;
  const ReportListCountUrl = `Report/PBSMS/PaymentReceived/Lot/count`;
  const ReportListExcelUrl = `Report/PBSMS/PaymentReceived/Lot/ExportToExcel`;
  const ReportListExcelFileName = "PBSMSPaymentReceivedLotWiseReport.xls";

  // api data manage
  const getdata = (setPageLimits = "", setItemPerPages = "") => {
    return JSON.stringify({
      start: setPageLimits === "" ? pageLimit : setPageLimits,
      length: setItemPerPages === "" ? itemPerPage : setItemPerPages,
      collection_season: Number(search.collectionSeason),
      tenderNo: search.tenderNo.trim(),
      circle_id: Number(search.circleId),
      district_id: Number(search.disctrictId),
      lot_no: search.lotNo.trim(),
      quantity_differ_id: Number(search.quantityDifferenceId),
      payment_types: Number(search.paymentTypes),
    });
  };

  useEffect(() => {
    setloading(true);
    reset();
    getReportCount(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated]);

  useEffect(() => {
    if (isSearch === false) {
      getReportList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticated, pageLimit]);

  useEffect(() => {
    if (isSearch) {
      getReportList();
      getReportCount();
      setIsClear(false);
      setIsSearch(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSearch, itemPerPage]);

  // pagging Disabled  manage
  const paggingDisabled = (isNext = true, isPrev = true) => {
    setdisablednext(isNext);
    setdisabledprev(isPrev);
  };
  // pagging Disabled Manage
  const paggingManage = (totalRecord, isRecordGet = true) => {
    setPageCount(parseInt(totalRecord) || 0);
    paggingDisabled(
      pageLimit >= parseInt(totalRecord) - parseInt(itemPerPage),
      pageLimit === 0
    );
  };

  // get Report List
  const getReportList = async () => {
    if (authenticated) {
      setloading(true);
      paggingDisabled();
      setUsersData();

      await apiCallSPPost(ReportListUrl, getdata(), [])
        .then((res) => {
          if (res.success) {
            debugger;
            setUsersData(res.data);

            if (isSearch === false && pageLimit >= 0 && pageCount > 0) {
              paggingManage(pageCount);
            }
          } else setUsersData();
        })
        .finally(() => {
          setloading(false);
        });
    }
  };

  // get Report List Count
  const getReportCount = async () => {
    if (authenticated) {
      await apiCallSPPost(ReportListCountUrl, getdata(0, 0), 0).then((res) => {
        if (res.success) paggingManage(parseInt(res.totalRecord) || 0);
        else paggingManage(0, false);
      });
    }
  };
  // get Report List ExportToExcel
  const ExportToExcel = async () => {
    setIsExporting(true);
    try {
      await apiExportToExcel(
        pageCount,
        ReportListExcelUrl,
        getdata(0, 0),
        ReportListExcelFileName
      ).finally(() => {
        setIsExporting(false);
      });
    } catch (error) {
      // Handle any errors that might occur during the export process
      console.error("Error exporting to Excel:", error);
      setIsExporting(false); // Reset isExporting state if an error occurs
    }
  };

  const reset = () => {
    setpageLimit(0);
  };

  // Search Model Value Update Manage
  const updateSearch = (e, name = "", value = "") => {
    updateSearchStatus(setSearch, search, e, name, value);
  };
  // Pagging Prev. Button Click Event
  const prevButton = () => {
    let pageLimitCheck = pageLimit - parseInt(itemPerPage);
    if (pageLimitCheck < 0) {
      pageLimitCheck = 0;
    }
    setpageLimit(pageLimitCheck);
  };
  // Pagging Next Button Click Event
  const nextButton = () => {
    let pageLimitCheck = pageLimit + parseInt(itemPerPage);
    if (pageLimitCheck >= parseInt(pageCount)) {
      pageLimitCheck = parseInt(pageCount);
      setdisablednext(true);
    }
    setpageLimit(pageLimitCheck);
  };
  // item per page  onChanage Event
  const onChangePage = (ev) => {
    ev.preventDefault();
    setpageLimit(0);
    setItemPerPage(ev.target.value);
    setIsSearch(true);
  };

  // Search Button Click Event
  const searchButton = (ev) => {
    ev.preventDefault();
    reset();
    setIsSearch(true);
  };

  //Clear Button Click Event
  const clearSearch = (ev) => {
    ev.preventDefault();
    reset();
    setIsClear(true);
    setIsSearch(true);
    setSearch({ ...search, ...SearchFilterModel });
    // setSearch({
    //   ...search,
    //   collectionSeason: 0,
    //   tenderId: 0,
    //   lotNo: "",
    //   circleId: 0,
    //   disctrictId: 0,
    //   quantityDifferenceId: 0,
    //   paymentTypes: 0,
    // });

    setUsersData();
  };

  //Search Filter Manage ( UI also)
  let additional = (
    <SearchFilter
      isDisabledSearchClear={loading}
      isClear={isClear}
      search={search}
      updateSearch={updateSearch}
      searchButton={searchButton}
      clearSearch={clearSearch}
      itemPerPage={itemPerPage}
      onChangePage={onChangePage}
      isExporting={isExporting}
      isDisabledExport={usersData && usersData.length > 0 ? false : true}
      ExportToExcel={ExportToExcel}
      searchQtyDifferDisplay={true}
      searchPaymentTypesDisplay={true}
    />
  );
let scopedSlotsList = {
    ABSOnline: (item, index) => {
      return (
        <td className="py-2">
          <span>
          
             {0 } 
          </span>
        </td>
      );
    },
  
  };
  const fields = [
    {
      key: "srNo",
      _style: { width: "5%" },
      label: "S.N.",
    },
    {
      key: "tenderNo",
      _style: { width: "5%" },
      label: "Tender No",
    },
      {
      key: "collectionSeason",
      _style: { width: "5%" },
      label: "Collection Season",
    },
    {
      key: "circleName",
      _style: { width: "15%" },
      label: "Circle",
    },
    {
      key: "districtName",
      _style: { width: "15%" },
      label: "District Union",
    },
    {
      key: "lotNo",
      _style: { width: "10%" },
      label: "Lot No.",
    },
    {
      key: "estimatedQuantity",
      _style: { width: "10%" },
      label: "Estimated Quantity (Per STD Bags)",
    },

    {
      key: "actualQuantity",
      _style: { width: "10%" },
      label: "Actual Quantity (Per STD Bags)",
    },
    {
      key: "saleRate",
      _style: { width: "10%" },
      label: "Sale Rate",
    },
    {
      key: "saleValue",
      _style: { width: "10%" },
      label: "Sale Value",
    },
    {
      key: "companyName",
      _style: { width: "20%" },
      label: "Company Name",
    },

    {
      key: "approx10PerEMD",
      _style: { width: "10%" },
      label: "Approx EMD (10%) ",
    },
    {
      key: "actual10PerEMD",
      _style: { width: "10%" },
      label: " Actual EMD (10%) ",
    },
    {
      key: "approx15PerSD",
      _style: { width: "10%" },
      label: "Approx Security Deposit (15%)",
    },
    {
      key: "actual15PerSD",
      _style: { width: "10%" },
      label: "Actual Security Deposit (15%)",
    },
    {
      key: "sD15PerPaid",
      _style: { width: "10%" },
      label: "Security Deposit Paid Online(15%)",
    },
  //  {
  //     key: "sD15PerPaidOnline",
  //     _style: { width: "10%" },
  //     label: "Security Deposit Paid Online(15%)",
  //   },
       {
      key: "sD15PerPaidBG",
      _style: { width: "10%" },
      label: "Security Deposit Paid BG(15%)",
    },
    {
      key: "addtSecurityDeposit",
      _style: { width: "10%" },
      label: "Addl. Security Deposit Received",
    },

    {
      key: "fullPayment",
      _style: { width: "10%" },
      label: "Full Payment",
    },
    {
      key: "godownRent",
      _style: { width: "10%" },
      label: "Godown Rent Received",
    },
    {
      key: "installmenT1",
      _style: { width: "10%" },
      label: "1st Installment Received",
    },
    {
      key: "installmenT2",
      _style: { width: "10%" },
      label: "2nd Installment Received",
    },
    {
      key: "installmenT3",
      _style: { width: "10%" },
      label: "3rd Installment Received",
    },
    {
      key: "installmenT4",
      _style: { width: "10%" },
      label: "4th Installment Received",
    },
    {
      key: "godwnQtyDiffAmount",
      _style: { width: "10%" },
      label: "Godown Qty Diff Amt",
    },
    {
      key: "absPayment",
      _style: { width: "10%" },
      label: "ABS Payment Online",
    },
        {
      key: "absPaymentBG",
      _style: { width: "10%" },
      label: "ABS Payment BG",
    },
    //     {
    //   key: "ABSOnline",
    //   _style: { width: "10%" },
    //   label: "ABS Payment Online",
    // },
    {
      key: "fivePreOnFinalAmt",
      _style: { width: "10%" },
      label: "5% Refund Amt",
    },
    // {
    //   key: "paymentType",
    //   _style: { width: "10%" },
    //   label: "Payment Type",
    // },
  ];

  return (
    <CommonList
      items={usersData}
      fields={fields}
      listName="Payment Received - Lot Wise Report"
      loading={loading}
      additional={additional}
      prev={prevButton}
      next={nextButton}
      disabledprev={disabledprev}
      disablednext={disablednext}
      // scopedSlots={scopedSlotsList}
      id="userid"
    />
  );
};

export default PBSMSPaymentReceivedLotWiseReport;
